import AbstractTransaction from './AbstractTransaction'
import BigNumber from 'bignumber.js'
import { Blockchain } from '@/constants/blockchain'
import { CURRENCY_FIELD_BACKEND_ID } from '@/constants/currency'
import { getCurrency } from '@/utils-ts/currencies'

export default class RefundToCustomerTransaction extends AbstractTransaction {
  static fromServer(data: LX.TransactionListItem, userId: number) {
    if (data) {
      const job = data.relations.Job || data.relations.GigJob
      const customerId = job?.customer_id
      if (customerId === userId) {
        const currency = getCurrency({
          blockchain: +(job.blockchain || Blockchain.Ethereum),
          value: +job.currency,
          field: CURRENCY_FIELD_BACKEND_ID,
        })
        const amount = new BigNumber(job.escrow_balance || 1).dividedBy(currency?.baseUnits || 1)
        return new RefundToCustomerTransaction({
          icon: 'refund.png',
          title: 'Contract Refund',
          wallet: (job.customer_wallet || '').toLowerCase(),
          amount,
          currency,
          created_at: data.created_at,
          event: data.event,
          tx_id: data.tx_id,
        })
      }
    }
  }
}
